// extracted by mini-css-extract-plugin
export default {"content":"style_content__dtilf","leftSide":"style_leftSide__sYDM8","rightSide":"style_rightSide__yhhlQ","type":"style_type__YVRbG"};